<template>
	<div class="advert-manage-container">
		<el-row :gutter="20">
			<el-col :span="8" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>房源业态分析</div>
						<div class="tip">
							<el-tooltip effect="dark" content="按面积统计" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart">
						<PieChart :categories="categories1" />
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>在租客户行业分析</div>
						<div class="tip">
							<el-tooltip effect="dark" content="按客户数量统计" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart">
						<PieChart :categories="categories2" />
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>在租客户公司性质分析</div>
						<div class="tip">
							<el-tooltip effect="dark" content="按客户数量统计" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart progress-chart">
						<div class="pei-chart-chart">
							<PieChart
								:categories="categories3"
								:option="{ legend: { show: false }, series: [{ center: ['50%', '50%'] }] }"
								title="总计" />
						</div>
						<div class="progress">
							<ProgressChart />
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="16" class="rows">
				<el-card shadow="never" style="background: #f0f5ff">
					<div class="header-row" slot="header">
						<div>在租客户面积分析</div>
						<div class="tip">
							<el-tooltip effect="dark" content="按面积区间统计" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart">
						<LeasedCustomerArea />
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>在租客户来源分析</div>
						<div class="tip">
							<el-tooltip effect="dark" content="按客户数量统计" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart">
						<div class="pie-chart progress-chart">
							<div class="pei-chart-chart">
								<PieChart
									:categories="categories4"
									:option="{ legend: { show: false }, series: [{ center: ['50%', '50%'] }] }"
									title="总计" />
							</div>
							<div class="progress">
								<ProgressChart />
							</div>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>在租客户Top10</div>
						<div class="tip">
							<el-select v-model="value" placeholder="请选择" size="mini" style="width: 120px">
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
							<div>更多</div>
						</div>
					</div>
					<div class="pie-chart">
						<LeasedCustomerTop />
					</div>
				</el-card>
			</el-col>
			<el-col :span="16" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>线索状态分析</div>
						<div class="tip">
							<el-tooltip effect="dark" content="按月统计线索状态" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart">
						<ClueStatus :xData="xData" :barData="barData" />
					</div>
				</el-card>
			</el-col>
			<el-col :span="24" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>线索漏斗分析图</div>
						<div class="tip">
							<el-tooltip effect="dark" content="展示线索转化情况" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart" style="height: 399px">
						<FunnelAnalysis />
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>线索成交周期分析</div>
						<div class="tip">
							<el-tooltip effect="dark" content="统计成交所需时间" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart">
						<LeadTransactionCycle />
					</div>
				</el-card>
			</el-col>
			<el-col :span="16" class="rows">
				<el-card shadow="never">
					<div class="header-row" slot="header">
						<div>线索来源分析</div>
						<div class="tip">
							<el-tooltip effect="dark" content="分析线索来源效果" placement="top">
								<i class="fa el-icon-info" style="color: #938e8e; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="pie-chart">
						<ClueSources :xData="xData" :barData="barData" :lineData="lineData" />
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import ProgressChart from '@/components/assets/progressChart.vue';
	import LeasedCustomerArea from '@/components/assets/leasedCustomerArea.vue';
	import LeasedCustomerTop from '@/components/assets/leasedCustomerTop.vue';
	import ClueStatus from '@/components/assets/clueStatus.vue';
	import ClueSources from '@/components/assets/clueSources.vue';
	import LeadTransactionCycle from '@/components/assets/leadTransactionCycle.vue';
	import FunnelAnalysis from '@/components/assets/funnelAnalysis.vue';
	export default {
		name: 'CustomerAnalysis',
		components: {
			ProgressChart,
			LeasedCustomerArea,
			LeasedCustomerTop,
			ClueStatus,
			ClueSources,
			LeadTransactionCycle,
			FunnelAnalysis,
		},
		data() {
			return {
				value: '合同总额',
				options: [
					{
						value: '合同总额',
						label: '合同总额',
					},
					{
						value: '收费面积',
						label: '收费面积',
					},
				],
				categories1: [
					{ name: '写字楼', value: 58 },
					{ name: '未知', value: 6 },
					{ name: '地上商业', value: 38 },
					{ name: '商场/街区', value: 38 },
					{ name: '公寓', value: 38 },
					{ name: '车位', value: 38 },
					{ name: '住宅', value: 38 },
				],
				categories2: [
					{ name: '未知', value: 58 },
					{ name: '互联网', value: 6 },
					{ name: '交通仓储', value: 38 },
					{ name: '公共服务', value: 38 },
					{ name: '制造业', value: 38 },
					{ name: '制造加工', value: 38 },
					{ name: '汽车服务', value: 38 },
					{ name: '艺术娱乐', value: 38 },
				],
				categories3: [
					{ name: '个人', value: 58 },
					{ name: '其他', value: 6 },
				],
				categories4: [
					{ name: '个人', value: 58 },
					{ name: '其他', value: 6 },
				],
				xData: ['2025-10', '2025-11', '2025-12', '2026-01', '2026-02', '2026-03', '2026-04'],
				barData: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6],
				lineData: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3],
			};
		},
		mounted() {},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		background-color: #f9fafc;
		text-align: left;

		:deep(.el-card) {
			border-radius: 16px;
			.el-card__header {
				border-bottom: none;
				padding-bottom: 0;
			}
		}
	}

	.header-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #0f172a;
		font-weight: 600;
		min-height: 36px;
		font-size: 16px;
	}

	.rows {
		margin-top: 18px;
	}

	.pie-chart {
		height: 286px;
		box-sizing: border-box;
	}

	.pei-chart-chart,
	.progress {
		width: 50%;
		height: 100%;
	}

	.progress-chart {
		display: flex;
		align-items: center;
	}

	.tip {
		display: flex;
		align-items: center;
		gap: 10px;
	}
</style>
